import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "common/components/ui/Dialog";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerTitle,
} from "common/components/ui/Drawer";
import authManager from "common/helpers/authManager";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

interface LogOutModalProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
}

export default function LogOutModal({ isOpen, setIsOpen }: LogOutModalProps) {
  const isDesktop = useTwBreakpoint("lg");

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;
  const Title = isDesktop ? DialogTitle : DrawerTitle;
  const Description = isDesktop ? DialogDescription : DrawerDescription;
  const Close = isDesktop ? DialogClose : DrawerClose;

  return (
    <Component open={isOpen} onOpenChange={setIsOpen}>
      <Content className="lg:w-[448px]">
        <Title>Are you sure you want to log out?</Title>

        <Description className="mb-12">
          You will be returned to the login screen
        </Description>

        <div className="flex justify-between gap-x-2.5">
          <Close asChild>
            <Button variant="secondary-black" className="lg:flex-1">
              Cancel
            </Button>
          </Close>

          <Button
            className="lg:flex-1"
            onClick={authManager.logout}
            data-cy="log-out-confirmation-button"
          >
            Log out
          </Button>
        </div>
      </Content>
    </Component>
  );
}
